import Input from '@/shared/components/UI/Input';
import LinkButton from '@/shared/components/UI/LinkButton';
import Button from '@/shared/components/UI/Button';

import { useLogin } from '../hooks/useLogin';

const Login = () => {
  const { formData, errors, isLoading, handleInputChange, handleSubmit } =
    useLogin();

  return (
    <section className="mx-auto w-full max-w-2xl text-center">
      <h2 className="mb-8 text-[24px] font-extrabold text-[#95699f]">LOGIN</h2>
      <form
        className="mx-auto flex w-80 flex-col items-center"
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <Input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleInputChange}
          error={errors.email}
          fullWidth={false}
          className="mb-3 w-[30rem] text-[14px]"
        />
        <Input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleInputChange}
          error={errors.password}
          fullWidth={false}
          className="mb-3 w-[30rem] text-[14px]"
        />
        <LinkButton
          to="/findpassword"
          variant="text"
          className="find-password-text mt-3 text-[14px]"
        >
          Forgot your password?
        </LinkButton>
        <Button
          type="submit"
          variant="secondary"
          size="md"
          disabled={isLoading}
          isLoading={isLoading}
          className="mt-10 w-40"
        >
          LOGIN
        </Button>
        <LinkButton
          to="/signup"
          variant="primary"
          className="mt-3 h-10 w-40 bg-[#b995be] px-6 hover:bg-[#95699f]"
        >
          SIGN UP
        </LinkButton>
      </form>
    </section>
  );
};

export default Login;
